import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input } from '~/components/Form';


import moment from 'moment';

import { t } from '~/helpers';
import api from '~/services/api';

import { number } from '~/helpers';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close }) {

  async function handleSubmit(param) {
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>
          <Input name="corredor" label="corredor" disabled />
          <Input name="postocodigo" label="postocodigo" disabled />
          <Input name="posto" label="posto" disabled />

          <Input name="capacidadecarreta" label="capacidadecarreta" disabled />
          <Input name="lastro" label="lastro" disabled />

          <Input name="tavi_capacidade" label="tavi_capacidade - calcula vli para ajuste" disabled />

          <Input name="tavi_capacidade_unidata" label="tavi_capacidade_unidata " disabled />

          <Input name="estoquetotalposto" label="estoquetotalposto" disabled />
          <Input name="volumeabastecidoperiodo" label="volumeabastecidoperiodo" disabled />
          <Input name="quantidaderegistrosabastecimentos" label="quantidaderegistrosabastecimentos" disabled />

          <Input name="estoquesobrerodas" label="estoquesobrerodas" disabled />

          <Input name="numerodiasparaperiodo" label="numerodiasparaperiodo" disabled />


          <Input name="calc_capacidade" label="calc_capacidade" disabled />
          <Input name="calc_fatorestoqueseguranca" label="calc_fatorestoqueseguranca" disabled />
          <Input name="calc_consumo_medio_dia" label="calc_consumo_medio_dia" disabled />
          <Input name="calc_estoqueutil" label="calc_estoqueutil" disabled />
          <Input name="calc_volumeporcento80" label="calc_volumeporcento ver campo (fatorestoqueporcento)" disabled />
          <Input name="calc_esperado" label="calc_esperado" disabled />
          <Input name="calc_numero_carretas_fracao" label="calc_numero_carretas_fracao" disabled />
          <Input name="calc_numero_carretas" label="calc_numero_carretas" disabled />
          <Input name="calc_numero_carretas_roundtrunk" label="calc_numero_carretas_roundtrunk" disabled />
          <Input name="calc_duracao_estoque_dias" label="calc_duracao_estoque_dias" disabled />
          <Input name="calc_espaco_vazio" label="calc_espaco_vazio" disabled />

          <Input name="calc_estoqueseguranca" label="calc_estoqueseguranca" disabled />

          <Input name="fatorestoqueporcento" label="fatorestoqueporcento" disabled />
          <Input name="nomecampoporcento" label="nomecampoporcento" disabled />
          <Input name="versaosistemausuario" label="versaosistemausuario" disabled />
          <Input name="observacao" label="observacao" disabled />

          <Input name="fatorestoqueseguraca" label="fatorestoqueseguranca" disabled />
          <Input name="mostrarposto" label="mostrarposto" disabled />
          <Input name="potr_data_trans" label="potr_data_trans" disabled />
          <Input name="calc_statuslinha" label="calc_statuslinha" disabled />
          <Input name="calc_duracao_estoque_dias_status" label="calc_duracao_estoque_dias_status" disabled />


        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
